module.exports = __webpack_public_path__ + "img/title-3.3268b4a1.png";